<script setup lang="ts">
import type { Ref } from "vue";
import { computed, ref } from "vue";

type Size = "small" | "large";

interface Props {
    value: number;
    min?: number;
    size?: Size;
}
const props = withDefaults(defineProps<Props>(), {
    min: 1,
    size: "large",
});
const value: Ref<number> = ref(props.value);

const emit = defineEmits<(e: "input", value: number) => void>();

const updateInput = () => {
    let amount = value.value;
    if (amount <= 0) amount = 1;
    emit("input", amount);
};
const incrementAmount = () => {
    value.value++;
    updateInput();
};
const decrementAmount = () => {
    value.value--;
    if (value.value <= 0) value.value = 1;
    updateInput();
};

const buttonSize = computed(() => {
    if (props.size == "large") return "w-10 h-14";
    return "w-8 h-8"; //small
});

const inputSize = computed(() => {
    if (props.size == "large") return "w-14 h-14";
    return "w-12 h-8"; //small // evt grow?
});
</script>

<template>
    <div class="flex flex-row md:mx-auto sm:mx-0 items-center border rounded-lg overflow-hidden sm:flex-nowrap ">
        <button type="button" @click.prevent="decrementAmount" :class="buttonSize" class="rounded-md flex items-center justify-center cursor-pointer relative after:content-[''] after:absolute after:top-0 after:border-r after:border-neutral-content after:h-14 after:right-0">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" class="text-lg text-base-200" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                <path d="M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"></path>
            </svg>
        </button>
        <input :class="inputSize" class="text-center focus:outline-hidden border-none text-sm font-normal text-secondary appearance-none [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
               type="number" min="1" v-model="value" @change="updateInput">
        <button type="button" @click.prevent="incrementAmount"
                :class="[
                buttonSize, {
                    'after:right-10': size == 'large',
                    'after:right-8': size == 'small',
                }]"
                class="flex items-center justify-center cursor-pointer relative after:content-[''] after:absolute after:top-0 after:border-r after:border-neutral-content after:h-14">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" class="text-lg text-base-200" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                <path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8Z"></path>
                <path d="M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8Z"></path>
            </svg>
        </button>
    </div>
</template>
